import { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import API from '../lib/api';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { DownloadSimple } from '@phosphor-icons/react';

export default function MobileReportsPage() {
  const { selectedBot, bots } = useOutletContext();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);

  const bot = bots.find(b => b.id === selectedBot);

  useEffect(() => {
    if (!selectedBot) { setReports([]); return; }
    setLoading(true);
    API.get(`/mobile-reports/${selectedBot}`).then(r => setReports(r.data.reports || [])).catch(() => toast.error('Failed')).finally(() => setLoading(false));
  }, [selectedBot]);

  const downloadCsv = () => {
    window.open(`${process.env.REACT_APP_BACKEND_URL}/api/mobile-reports/${selectedBot}/csv`, '_blank');
  };

  if (!selectedBot) {
    return (
      <div className="space-y-4" data-testid="mobile-reports-page">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" style={{ fontFamily: 'Cabinet Grotesk' }}>Mobile Reports</h1>
        <div className="border border-dashed border-border rounded-md p-12 text-center text-muted-foreground">Select a bot from the sidebar</div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="mobile-reports-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" style={{ fontFamily: 'Cabinet Grotesk' }}>Mobile Reports</h1>
          <p className="text-sm text-muted-foreground mt-1">{reports.length} numbers collected from {bot?.bot_name}</p>
        </div>
        <Button data-testid="download-mobile-csv" variant="outline" onClick={downloadCsv} disabled={reports.length === 0} className="gap-2">
          <DownloadSimple size={18} /> Download CSV
        </Button>
      </div>

      {loading ? <div className="text-center py-12 text-muted-foreground">Loading...</div> : (
        <div className="border border-border rounded-md overflow-x-auto">
          <table className="w-full text-sm min-w-[500px]">
            <thead>
              <tr className="bg-muted/50 border-b border-border">
                <th className="text-left px-4 py-3 font-medium text-xs uppercase tracking-wider">User ID</th>
                <th className="text-left px-4 py-3 font-medium text-xs uppercase tracking-wider">Username</th>
                <th className="text-left px-4 py-3 font-medium text-xs uppercase tracking-wider">Name</th>
                <th className="text-left px-4 py-3 font-medium text-xs uppercase tracking-wider">Mobile Number</th>
                <th className="text-left px-4 py-3 font-medium text-xs uppercase tracking-wider">Collected At</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((r, i) => (
                <tr key={r.id || i} className={`border-b border-border ${i % 2 === 0 ? '' : 'bg-muted/20'}`}>
                  <td className="px-4 py-3 font-mono text-xs">{r.telegram_user_id}</td>
                  <td className="px-4 py-3">{r.username || '-'}</td>
                  <td className="px-4 py-3">{r.first_name || '-'}</td>
                  <td className="px-4 py-3 font-mono">{r.mobile_number}</td>
                  <td className="px-4 py-3 font-mono text-xs">{r.collected_at?.replace('T', ' ').slice(0, 19)}</td>
                </tr>
              ))}
              {reports.length === 0 && (
                <tr><td colSpan={5} className="px-4 py-8 text-center text-muted-foreground">No mobile numbers collected yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
